// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "362" ? "__federation_expose_App" : chunkId) + "." + {"229": "ff2f23e4","362": "b6484079",}[chunkId] + ".js"
}